import { colors } from "../../../../data/colors";
import { useStructureContext } from "../../../../context/StructureContext";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import AddchartIcon from "@mui/icons-material/Addchart";
import useCreateIcon from "./useCreateIcon";
import {
  extrasNewCodes,
  personsCodes,
  shortcutCodes,
} from "../../../../data/main";
import { useHotkeys } from "react-hotkeys-hook";
import { useMainContext } from "../../../../context/MainContext";
import { stdObject } from "../../../../data/types/stdObject";
import { toShortcut } from "../../../../utils/toShortcut";
import { sectionsList } from "../../../../data/sectionsList";

export default function CreateIcon() {
  const { type, section, sendNewInfo } = useStructureContext();
  const { mainMenuheader, checkIfAllMsgClean } = useMainContext();
  const { iconStyle } = useCreateIcon();

  const specificIcon = () => {
    switch (section.code) {
      case "SUC":
        return <AddBusinessIcon style={iconStyle} />;
      case "ROL":
        return <GroupAddIcon style={iconStyle} />;
      case "STA":
      case "ADM":
      case "ISU":
      case "ACO":
      case "CAT":
      case "MAR":
      case "ICA":
      case "SHI":
      case "BCK":
      case "D8":
        return <LibraryAddIcon style={iconStyle} />;
      case "V1":
        return <AddchartIcon style={iconStyle} />;
      default:
        return <PersonAddAlt1Icon style={iconStyle} />;
    }
  };

  useHotkeys(
    toShortcut(shortcutCodes.new),
    () =>
      checkIfAllMsgClean() &&
      sectionsList.find((e: stdObject) => e.type === type)?.id ===
        mainMenuheader.id &&
      sendNewInfo({ code: "", nextDate: null }),
    {
      preventDefault: true,
    },
  );

  return (
    <div className="createNew">
      <div
        className="createContainer"
        style={{ backgroundColor: colors[type] }}
        onClick={sendNewInfo}
      >
        <div style={{ marginTop: 3 }} title={shortcutCodes.new}>
          {extrasNewCodes.includes(section.code) ? (
            specificIcon()
          ) : personsCodes.includes(section.code) ? (
            <PersonAddAlt1Icon style={iconStyle} />
          ) : (
            <NoteAddIcon style={iconStyle} />
          )}
        </div>
      </div>
    </div>
  );
}
